var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotTableComponent",class:_vm.classMain,attrs:{"tabindex":"0"}},[_c('div',{ref:"hotTableComponent"})])}
var staticRenderFns = []

export { render, staticRenderFns }